import { createInertiaApp } from '@inertiajs/react'
import { createElement } from 'react'
import { createRoot } from 'react-dom/client'
import 'leaflet/dist/leaflet.css'
import '../lib/sentry'

const el = document.getElementById('app')
if (!el) {
  console.warn('Inertia app element not found, skipping initialization')
} else {
  createInertiaApp({
    resolve: name => {
      const pages = import.meta.glob('../Pages/**/*.jsx', { eager: true })
      const page = pages[`../Pages/${name}.jsx`]
      if (!page) {
        throw new Error(`Page not found: ${name}. Available: ${Object.keys(pages).join(', ')}`)
      }
      return page.default || page
    },
    setup({ el, App, props }) {
      const root = createRoot(el)
      root.render(createElement(App, props))
    },
  })
}
